import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7daf9bc9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "header-item" }
const _hoisted_3 = { class: "ceci-info" }

import { computed } from 'vue'
import { CeciConfig } from '@/types'

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'detail',
  props: {
    data: {}
  },
  setup(__props: any) {

const props = __props

// Computed property for subtitle
const subtitle = computed(() => {
  let subtitle = ''
  if (props.data.period) {
    subtitle += (subtitle ? ' - ' : '') + props.data.period
  }
  if (props.data.grade) {
    subtitle += (subtitle ? ' - ' : '') + props.data.grade
  }
  if (props.data.term) {
    subtitle += (subtitle ? ' - ' : '') + props.data.term
  }
  return subtitle
})

return (_ctx: any,_cache: any) => {
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_divider = _resolveComponent("el-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_text, { truncated: "" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.data.title), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_tag, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.data.platform), 1)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_divider),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_text, { truncated: "" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(subtitle.value), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})